export const renderRateAsPercentage = (rate: number) => {
  return `${(rate / 100).toFixed(2)}%`;
};
